// 省份名稱國際化 - 繁體中文
export default {
  北京市: "北京市",
  天津市: "天津市",
  河北省: "河北省",
  山西省: "山西省",
  内蒙古自治区: "內蒙古自治區",
  辽宁省: "遼寧省",
  吉林省: "吉林省",
  黑龙江省: "黑龍江省",
  上海市: "上海市",
  江苏省: "江蘇省",
  浙江省: "浙江省",
  安徽省: "安徽省",
  福建省: "福建省",
  江西省: "江西省",
  山东省: "山東省",
  河南省: "河南省",
  湖北省: "湖北省",
  湖南省: "湖南省",
  广东省: "廣東省",
  广西壮族自治区: "廣西壯族自治區",
  海南省: "海南省",
  重庆市: "重慶市",
  四川省: "四川省",
  贵州省: "貴州省",
  云南省: "雲南省",
  西藏自治区: "西藏自治區",
  陕西省: "陝西省",
  甘肃省: "甘肅省",
  青海省: "青海省",
  宁夏回族自治区: "寧夏回族自治區",
  新疆维吾尔自治区: "新疆維吾爾自治區",
  台湾省: "台灣省",
  香港特别行政区: "香港特別行政區",
  澳门特别行政区: "澳門特別行政區",
};

